export const distance = [
    { id: 0, name: 'Any distance',    meters: 8047 },
    { id: 1, name: 'Within 1 mile',   meters: 1609 },
    { id: 2, name: 'Within 5 miles',  meters: 8047 },
    { id: 3, name: 'Within 10 miles', meters: 16093 },
    { id: 4, name: 'Within 25 miles', meters: 40234 },
];
